import { render, staticRenderFns } from "./yuList.vue?vue&type=template&id=5eaf9878&scoped=true"
import script from "./yuList.vue?vue&type=script&lang=js"
export * from "./yuList.vue?vue&type=script&lang=js"
import style0 from "./yuList.vue?vue&type=style&index=0&id=5eaf9878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf9878",
  null
  
)

export default component.exports